import { hexagrams } from '../data/hexagrams';
import hexagramMeanings from '../data/hexagramMeanings';

export function calculateHexagram(phoneNumber) {
  if (!phoneNumber || phoneNumber.length !== 10) return null;
  
  const digits = phoneNumber.split('').map(Number);
  
  const tens = (digits[0] + digits[1] + digits[2] + digits[3] + digits[4]) % 8;
  const units = (digits[5] + digits[6] + digits[7] + digits[8] + digits[9]) % 8;
  const mainHexagram = tens * 10 + units;
  
  let movingLine = (digits.reduce((sum, d) => sum + d, 0)) % 6;
  movingLine = movingLine === 0 ? 6 : movingLine;
  
  const transformedTens = calculateTransformedTens(tens, movingLine);
  const transformedUnits = calculateTransformedUnits(units, movingLine);
  const transformedHexagram = transformedTens * 10 + transformedUnits;

  const mainHexagramName = hexagrams[mainHexagram];
  const transformedHexagramName = hexagrams[transformedHexagram];

  const numberPairs = [
    { 
      pair: `${digits[0]}${digits[1]}`, 
      hexagram: hexagrams[digits[0] * 10 + digits[1]], 
      hexagramMeaning: hexagramMeanings[hexagrams[digits[0] * 10 + digits[1]]]?.meaning || "Chưa có dữ liệu"
    },
    { 
      pair: `${digits[2]}${digits[3]}`, 
      hexagram: hexagrams[digits[2] * 10 + digits[3]], 
      hexagramMeaning: hexagramMeanings[hexagrams[digits[2] * 10 + digits[3]]]?.meaning || "Chưa có dữ liệu"
    },
    { 
      pair: `${digits[4]}${digits[5]}`, 
      hexagram: hexagrams[digits[4] * 10 + digits[5]], 
      hexagramMeaning: hexagramMeanings[hexagrams[digits[4] * 10 + digits[5]]]?.meaning || "Chưa có dữ liệu"
    },
    { 
      pair: `${digits[6]}${digits[7]}`, 
      hexagram: hexagrams[digits[6] * 10 + digits[7]], 
      hexagramMeaning: hexagramMeanings[hexagrams[digits[6] * 10 + digits[7]]]?.meaning || "Chưa có dữ liệu"
    },
    { 
      pair: `${digits[8]}${digits[9]}`, 
      hexagram: hexagrams[digits[8] * 10 + digits[9]], 
      hexagramMeaning: hexagramMeanings[hexagrams[digits[8] * 10 + digits[9]]]?.meaning || "Chưa có dữ liệu"
    }
  ];
  
  return {
    main: {
      number: mainHexagram,
      name: mainHexagramName,
      meaning: hexagramMeanings[mainHexagramName]?.meaning || "Chưa có dữ liệu"
    },
    movingLine,
    transformed: {
      number: transformedHexagram,
      name: transformedHexagramName,
      meaning: hexagramMeanings[transformedHexagramName]?.meaning || "Chưa có dữ liệu"
    },
    numberPairs,
    energyDetails: [],
    phoneNumber
  };
}

function calculateTransformedTens(tens, movingLine) {
  if ([1, 2, 3].includes(movingLine)) return tens;
  
  const transformations = {
    4: {1:5, 2:6, 3:7, 4:8, 5:1, 6:2, 7:3, 8:4, 0:4},
    5: {1:3, 2:4, 3:1, 4:2, 5:7, 6:8, 7:5, 8:6, 0:6},
    6: {1:2, 2:1, 3:4, 4:3, 5:6, 6:5, 7:8, 8:7, 0:7},
    0: {1:2, 2:1, 3:4, 4:3, 5:6, 6:5, 7:8, 8:7, 0:7}
  };
  
  return transformations[movingLine]?.[tens] || tens;
}

function calculateTransformedUnits(units, movingLine) {
  if ([0, 4, 5].includes(movingLine)) return units;
  
  const transformations = {
    1: {1:5, 2:6, 3:7, 4:8, 5:1, 6:2, 7:3, 8:4, 0:4},
    2: {1:3, 2:4, 3:1, 4:2, 5:7, 6:8, 7:5, 8:6, 0:6},
    3: {1:2, 2:1, 3:4, 4:3, 5:6, 6:5, 7:8, 8:7, 0:7}
  };
  
  return transformations[movingLine]?.[units] || units;
}
